module.exports = __webpack_public_path__ + "img/casino-evolution.8aaa207d.jpg";